export enum SettingsFocusKeys {
  Login = "SETTINGS:LOGIN",
  Language = "SETTINGS:LANGUAGE",
  PrivacySettings = "SETTINGS:PRIVACY_SETTINGS",
  PrivacyDefault = "PRIVACYSETTINGS:DEFAULT",
  StreamingDefault = "STREAMING:DEFAULT",
  Imprint = "SETTINGS:IMPRINT",
  Terms = "SETTINGS:TERMS",
  PrivacyPolicy = "SETTINGS:PRIVACY_POLICY",
  AdditionalDataInfo = "SETTINGS:ADDITIONAL_DATA",
  OpenSourceLicences = "SETTINGS:OPEN_SOURCE_LICENCES",
  Streaming = "SETTINGS:STREAMING",
  DebugMenu = "SETTINGS:DEBUGMENU",
  DebugDefault = "SETTINGS:DEBUGDEFAULT",
  DebugFrontendSwitch = "SETTINGS:DEFRONTENDSWITCH",
  DebugDisable = "SETTINGS:DEBUGDISABLE",
  RestartTour = "SETTINGS:RESTARTTOUR",
  Accessibility = "SETTINGS:ACCESSIBILITY",
  AccessibilityDefault = "SETTINGS:ACCESSIBILITYDEFAULT",
  AccessibilityInfo = "SETTINGS:ACCESSIBILITYINFO",
}
